// While a gift is incomplete (blank note, more notes than cards, or a gift box with empty slots),
// a transparent layer covers the express payment buttons. Tapping it presses the cart's own
// Checkout button so shoppers get the same warning or popup instead of skipping the gift checks.
document.addEventListener('click', function (event) {
  var guard = event.target.closest('[data-express-guard]');
  if (!guard) return;
  event.preventDefault();
  event.stopPropagation();
  var form = guard.closest('form');
  var checkout = form && form.querySelector('button[name="checkout"], [type="submit"][name="checkout"]');
  if (checkout) checkout.click();
}, true);
